<template>
  <div>
    <router-link
      target="_blank"
      :to="{
              name: 'CascadingElements',
              params: {
                element_id: scope.row.id,
                parent_id: null,
              }
            }"
    >
      <el-button
        class="table-action-button"
        round
        icon="fas fa-wrench"
      ></el-button>
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'cascading-element-actions-table-column',
  components: {},
  mixins: [],

  props: {
    scope: {type: Object, required: true},
  },
  data() {
    return {}
  },
  methods: {}
}

</script>

<style lang="scss">
@import "@/assets/css/project-variables";

</style>
